import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=64746739&scoped=true"
import script from "./detailInfo.vue?vue&type=script&lang=js"
export * from "./detailInfo.vue?vue&type=script&lang=js"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=64746739&prod&scoped=true&lang=scss"
import style1 from "./detailInfo.vue?vue&type=style&index=1&id=64746739&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64746739",
  null
  
)

export default component.exports